module.exports = __webpack_public_path__ + "media/background.aa1f252f.mp4";